import React from "react";
import {css} from "emotion";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {colors, textSizes, boxStyles} from "../../styles/theme";
import Pulse from "../Pulse";

const MenuItem = ({route}) => {
  const embedPulse = localStorage.getItem('embedPulse');
  let currentUrl = window.location.href.toLowerCase();
  let isActive =
    currentUrl.includes(route) || (route === "home" && currentUrl.indexOf(""));

  let icon;
  switch (route) {
    case "home":
      icon = "home";
      break;
    case "embed":
      icon = "code";
      break;
    case "plans":
      icon = "rocket";
      break;
    case "settings":
      icon = "cog";
      break;
    case "support":
      icon = "phone";
      break;
    case "billing":
      icon = "credit-card";
      break;
    default:
      icon = "home";
      break;
  }

  return (
    <Link to={`/${route}`} className={container + ` ${isActive ? active : ""} ${route === 'embed' && embedPulse ? 'pulse' : ''}`}>
      <div className="content">
        <div className="icon-container">
          <FontAwesomeIcon className="icon" icon={icon}/>
        </div>
        <p>{route}</p>
        <div className="bar"></div>
        {route === 'embed' && embedPulse && <Pulse/>}
      </div>
    </Link>
  );
};

export default MenuItem;

const container = css`
  text-decoration: none;
  transition-duration: 200ms;
  background-color: white;
  .content {
    position: relative;
    display: flex;
    align-items: center;
    padding: ${boxStyles.desktopPadding} 0;
    .icon-container {
      display: flex;
      width: 30px;
      .icon {
        font-size: 14px;
        color: ${colors.placeholderText};
        transition-duration: 200ms;
      }
    }
    p {
      margin: 0 10px;
      text-transform: capitalize;
      color: ${colors.titleColor};
      font-size: ${textSizes.normal};
      transition-duration: 200ms;
    }
    .bar {
      position: absolute;
      left: 90px;
      border-radius: 30px;
      height: 14px;
      width: 3px;
      background-color: ${colors.brandColor};
      opacity: 0;
      transition-duration: 200ms;
    }

    &:hover {
      .bar {
        opacity: 1;
      }
      .icon {
        color: ${colors.brandColor};
      }
    }
  }
  
  &.pulse {
    &:hover {
      .bar {
        display: none;
      }
    }
  }

  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    .content {
      .icon-container {
        justify-content: flex-end;
      }
      p {
        font-weight: bold;
        font-size: ${textSizes.intermediate};
      }
    }
  }
`;

const active = css`
  .content {
    .bar {
      display: block;
      opacity: 1;
    }
    .icon-container {
      .icon {
        color: ${colors.brandColor};
      }
    }
  }
  
  &.pulse {
    .bar {
      display: none;
    }
  }
  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    background-color: #4996e914;
    .content {
      .bar {
        display: none;
      }
    }
  }
`;
